export const movieTypes = {
  all: "ALL_MOVIES",
  toggleDarkMode: "TOGGLE_DARK_MODE",
  toggleLanguage: "TOGGLE_LANGUAGE",
};

// API From TMDB
export const API = "a579beaa78523fb5d1e557ccb383c5f9";

// variable to store the beginning of the URL for each image
export const beginningImg = "https://image.tmdb.org/t/p/w500";
